export default __webpack_public_path__ + "static/notificationsplay-d832a80dde0c061a669da747f98a80d1.png";